"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _size2 = _interopRequireDefault(require("lodash/size"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _localization = require("@lt/localization");

var _SearcherAbstractFilters = _interopRequireDefault(require("./SearcherAbstractFilters"));

var _FreeCancellation = _interopRequireDefault(require("../../icons-react/userflow/FreeCancellation"));

var _excluded = ["name", "icon"],
    _excluded2 = ["options", "activeFilters", "isMobile", "isHotelOnly"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var InstantConfrimIcon = function InstantConfrimIcon(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("linearGradient", {
    id: "instant-confirm_svg__a",
    x1: "50%",
    x2: "50%",
    y1: "100%",
    y2: "0%"
  }, /*#__PURE__*/_react["default"].createElement("stop", {
    offset: "0%",
    stopColor: "#5BC9F5"
  }), /*#__PURE__*/_react["default"].createElement("stop", {
    offset: "100%",
    stopColor: "#2080F1"
  }))), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "url(#instant-confirm_svg__a) #009df9",
    fillRule: "evenodd",
    d: "M291.237 3071l-9.075 12.238 3.218.19-1.276 8.959 8.898-12.964-2.936-.202z",
    transform: "translate(-282 -3071)"
  }));
};

InstantConfrimIcon.defaultProps = {
  className: "instant-confirm_svg__instant-confirm-icon",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 11 22"
};

var GiftIcon = function GiftIcon(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("mask", {
    id: "gift_svg__a",
    fill: "#fff"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5 12v10h18V12"
  })), /*#__PURE__*/_react["default"].createElement("path", {
    className: "gift_svg__gift-icon-body",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5 12v10h18V12",
    fill: "transparent"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    className: "gift_svg__gift-icon-border",
    fill: "#17181A",
    mask: "url(#gift_svg__a)",
    d: "M3.5 22h-1v1h1v-1zm18 0v1h1v-1h-1zm-19-10v10h2V12h-2zm1 11h18v-2h-18v2zm19-1V12h-2v10h2z"
  }), /*#__PURE__*/_react["default"].createElement("mask", {
    id: "gift_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.278 12H2.5V7h20v5h-7.778"
  })), /*#__PURE__*/_react["default"].createElement("path", {
    className: "gift_svg__gift-icon-body",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.278 12H2.5V7h20v5h-7.778",
    fill: "transparent"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    className: "gift_svg__gift-icon-border",
    fill: "#17181A",
    mask: "url(#gift_svg__b)",
    d: "M2.5 12h-1v1h1v-1zm0-5V6h-1v1h1zm20 0h1V6h-1v1zm0 5v1h1v-1h-1zm-12.222-1H2.5v2h7.779v-2zM3.5 12V7h-2v5h2zm-1-4h20V6h-20v2zm19-1v5h2V7h-2zm1 4h-7.778v2H22.5v-2z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    className: "gift_svg__gift-icon-bow",
    stroke: "#17181A",
    fill: "transparent",
    d: "M14.5 8v14m-4-14v14m1.732-15.171c.093.26.16.486.206.668-1.175.025-2.688-.087-3.963-.483C6.958 6.54 6 5.752 6 4.523c0-.692.195-1.167.465-1.48.272-.313.657-.504 1.114-.562.929-.119 2.11.326 2.916 1.332.95 1.185 1.462 2.253 1.737 3.016zm.536 0c-.093.26-.16.486-.206.668 1.175.025 2.688-.087 3.963-.483C18.042 6.54 19 5.752 19 4.523c0-.692-.195-1.167-.465-1.48-.272-.313-.657-.504-1.114-.562-.928-.119-2.11.326-2.915 1.332-.95 1.185-1.463 2.253-1.738 3.016z"
  }));
};

GiftIcon.defaultProps = {
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 25 24"
};
var ICON_TYPES = {
  instant_confirm: InstantConfrimIcon,
  lt_extras: GiftIcon,
  free_cancel: _FreeCancellation["default"]
};

var prepareOptions = function prepareOptions(options) {
  return options.map(function (option) {
    return {
      label: option.label,
      filters: option.filters.map(function (_ref) {
        var name = _ref.name,
            icon = _ref.icon,
            rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
        var FilterIcon = ICON_TYPES[icon];

        var nameWithIcon = function nameWithIcon() {
          return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, name, "\xA0", FilterIcon && /*#__PURE__*/_react["default"].createElement(StyledCheckboxIcon, null, /*#__PURE__*/_react["default"].createElement(FilterIcon, null)));
        };

        return _objectSpread({
          name: nameWithIcon()
        }, rest);
      })
    };
  });
};

var prepareLabelFilter = function prepareLabelFilter(activeFilters, isMobile) {
  var activeFiltersCount = (0, _size2["default"])(activeFilters);

  var _useTranslation = (0, _localization.useTranslation)(),
      t = _useTranslation.t;

  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, t('hotel.filters.title'), activeFiltersCount > 0 && /*#__PURE__*/_react["default"].createElement(ActiveCount, {
    isMobile: isMobile
  }, activeFiltersCount));
};

var SearcherFilters = function SearcherFilters(_ref2) {
  var options = _ref2.options,
      activeFilters = _ref2.activeFilters,
      _ref2$isMobile = _ref2.isMobile,
      isMobile = _ref2$isMobile === void 0 ? false : _ref2$isMobile,
      isHotelOnly = _ref2.isHotelOnly,
      props = (0, _objectWithoutProperties2["default"])(_ref2, _excluded2);
  return /*#__PURE__*/_react["default"].createElement(_SearcherAbstractFilters["default"], (0, _extends2["default"])({
    isFiltersMobile: false,
    isMobile: isMobile,
    label: prepareLabelFilter(activeFilters, isMobile),
    defaultValue: activeFilters,
    options: prepareOptions(options),
    position: "right",
    isHotelOnly: isHotelOnly
  }, props));
};

var ActiveCount = _styledComponents["default"].span.withConfig({
  displayName: "SearcherFilters__ActiveCount",
  componentId: "sc-m5j8j5-0"
})(["width:16px;height:16px;margin:0 4px;background-color:#fff;color:#007aff;position:relative;vertical-align:middle;bottom:", "px;display:inline-flex;border-radius:50%;justify-content:center;align-items:center;"], function (_ref3) {
  var isMobile = _ref3.isMobile;
  return isMobile ? 2 : 0;
});

var StyledCheckboxIcon = _styledComponents["default"].span.withConfig({
  displayName: "SearcherFilters__StyledCheckboxIcon",
  componentId: "sc-m5j8j5-1"
})(["svg{margin-bottom:-3px;width:16px;height:16px;stroke:initial;stroke-width:initial;}svg.gift-icon .gift-icon__body{fill:#f8e71c;}svg.instant-confirm-icon{position:relative;border-radius:50%;padding:2px;background:linear-gradient(180deg,#2080f1 0%,#5bc9f5 100%);path{fill:#fff;}}"]);

var _default = SearcherFilters;
exports["default"] = _default;